"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ParkingSpotEntity_1 = __importDefault(require("./Entity/ParkingSpotEntity"));
var ParkingSpotApi = /** @class */ (function () {
    function ParkingSpotApi(session) {
        this.parkingSpotEntity = new ParkingSpotEntity_1.default(session);
    }
    ParkingSpotApi.prototype.getParkingSpots = function (teamId, parkingType) {
        return this.parkingSpotEntity.getParkingSpots(teamId, parkingType);
    };
    return ParkingSpotApi;
}());
exports.default = ParkingSpotApi;
//# sourceMappingURL=ParkingSpotApi.js.map